import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import styled from "styled-components"; //eslint-disable-line
import { css } from "styled-components/macro"; //eslint-disable-line
import Header from "components/headers/light.js";
import Footer from "components/footers/FiveColumnDark";
import MainFeature1 from "components/features/TwoColWithButton.js";
import Features from "components/features/ThreeColSimple.js";
import TeamCardGrid from "components/cards/ProfileThreeColGrid.js";
import TwoColumnWithVideo from "components/hero/TwoColumnWithVideo";
import GetStarted from "components/cta/GetStarted";
import ContactUs from "pages/ContactUs";
import TwoColContactUsWithIllustrationFullForm from "components/forms/TwoColContactUsWithIllustrationFullForm";

// Images related to Android tech stack
import AndroidImage1 from "../../images/Digital lifestyle-amico.png"; // Add the image of Android development here
import AndroidImage2 from "../../images/Mobile apps-amico.svg";
import KotlinIcon from "../../images/icons8-kotlin-50.png"; // Kotlin logo
import JavaIcon from "../../images/icons8-java-50.png"; // Java logo
import XMLIcon from "../../images/icons8-xml-50.png"
import JetpackIcon from "../../images/jetpack-compose-logo.png"
import SpiralIcon from "../../images/icons8-spiral-50.png"


const Subheading = tw.span`uppercase tracking-wider text-sm`;

export default ({ roundedHeaderButton }) => {
  return (
    <AnimationRevealPage>
      {/* Hero Section */}
      <TwoColumnWithVideo
        heading="Android Technologies for Building Modern Mobile Apps"
        buttonRounded={false}
        primaryButtonText="Request Free Consultation"
        primaryButtonUrl="https://calendly.com/solutions-tbnw/30min?month=2024-11"
        description="Our team specializes in Android app development using technologies like Kotlin, Java, and Android Studio to build high-performance, scalable, and user-friendly mobile applications. Whether you're building a new app or enhancing an existing one, we have the expertise to bring your idea to life."
        imageSrc={AndroidImage1} // Android-related image (e.g., Android phone, logo, etc.)
      />

      {/* Main Feature Section */}
      <MainFeature1
        subheading={<Subheading>Our Expertise</Subheading>}
        heading="Ready to Build Your Next Android App?"
        buttonRounded={false}
        primaryButtonText="Contact Us"
        primaryButtonUrl="/contactus"
        description="We help businesses create native Android applications using Kotlin, Java, and Jetpack Compose, ensuring a seamless user experience and powerful functionality. Let's turn your ideas into a fully-featured app."
        textOnLeft={false}
        imageSrc={AndroidImage2}
      />

      {/* Feature Section */}
      <Features
        heading="Android Technology Stack"
        description="Our Android development team uses a wide range of tools and frameworks to create robust and feature-rich mobile applications. Here's a look at the technologies we use."
        cards={[
          {
            imageSrc: KotlinIcon,
            title: "Kotlin",
            description: "Kotlin is the modern programming language for Android development, known for its conciseness and interoperability with Java."
          },
          {
            imageSrc: JavaIcon,
            title: "Java",
            description: "Java is a well-established programming language and one of the primary languages for Android development, offering a wide range of libraries and frameworks."
          },
          {
            imageSrc: XMLIcon,
            title: "XML Layouts",
            description: "XML is the foundation for UI design in Android apps. We use XML layouts to define the structure and appearance of your app’s UI elements."
          },
          {
            imageSrc: SpiralIcon,
            title: "MVI Architecture",
            description: "Model-View-Intent (MVI) is a clean architecture pattern that helps us build robust, maintainable Android apps by clearly separating the UI, logic, and data layers."
          },
          {
            imageSrc: JetpackIcon,
            title: "Jetpack Compose",
            description: "Jetpack Compose is a modern, fully declarative UI toolkit that allows us to build Android UIs faster and more efficiently with Kotlin."
          }
        ]}
      />

      {/* Get Started Section */}
      <GetStarted />

      {/* Contact Us Section */}
      <TwoColContactUsWithIllustrationFullForm />

      {/* Footer */}
      <Footer />
    </AnimationRevealPage>
  );
};
